import { useNavigate } from 'react-router-dom';
import IcBack from '../../assets/image/ic_arrow_left.svg';

export default function BackButton() {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      style={{
        height: '48px',
      }}
    >
      <img
        src={IcBack}
        style={{
          marginLeft: '16px',
        }}
        alt="back"
      />
    </button>
  );
}
